// code for Footer accordian section.
(function(){
    let mediaQueryResult =  window.matchMedia("(max-width: 1100px)"),
    accordionHeadings = document.querySelectorAll(".accordion-title"),
    accordionContent = document.querySelectorAll('.accordion-content'),
    showLessMoreProductContent = () => {
      location.href.includes('/products/') && document.querySelector('.key-feature-list').addEventListener('click', (e)=> {
        let target = e.target,
          productDescription = target.closest('.product-description'),
          shortDescription = target.closest('.product-description').querySelector('.description-short'),
          longDescription = target.closest('.product-description').querySelector('.description-full'),
          showMoreBtn = target.closest('.product-description').querySelector('.show-more'),
          showLessBtn = target.closest('.product-description').querySelector('.show-less');
         [showLessBtn, showMoreBtn, longDescription, shortDescription].forEach(ele => ele.classList.toggle('hide'));
      });
    },
    implementAccordion = mediaQueryResult => {
        if(mediaQueryResult.matches){
            hidePanels();
            accordionHeadings.forEach((heading, index) => {
                heading.addEventListener('click', (e)=>{
                  let heading = e.currentTarget;
                  (heading.nextElementSibling.style.maxHeight)? hidePanels() : showPanel(heading);
                })
            })
        }
    },
    showPanel = element => {
        hidePanels();
        element.classList.add("active");
        element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + "px";
    },
    hidePanels = () => {
        accordionHeadings.forEach((heading, index) => {
            accordionContent[index].style.maxHeight = null;
            heading.classList.remove('active');
        });
    },
    init = () => {
        implementAccordion(mediaQueryResult);
        mediaQueryResult.addEventListener('change', (e)=>{
          implementAccordion(mediaQueryResult);
        });
      showLessMoreProductContent();
    };
    init();
})();
// code for Tab section.

try{

  function openTab(event, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  event.currentTarget.className += " active";
}

document.querySelector(".tabs-content-wrap.ced-custom").click();
  
}catch(e){
  console.warn(e);
  
}



// education tab height dependent

window.addEventListener('load', function() {
  var sideBarMenuHeight = document.querySelector('.dependent-height').offsetHeight;
  var sideBarMenuItems = document.querySelectorAll('.side-bar-menu_item');
  
  sideBarMenuItems.forEach(function(item) {
    item.style.minHeight = sideBarMenuHeight + 'px';
  });
});

